import { c as _c } from "react/compiler-runtime";
import type { ApiWave } from "@/generated/models/ApiWave";
import type { ActiveDropState } from "@/types/dropInteractionTypes";
import { useDropPrivileges } from "@/hooks/useDropPriviledges";
import { useAuth } from "../auth/Auth";
import DropPlaceholder from "./DropPlaceholder";
import CreateDrop from "./CreateDrop";
import { DropMode, type CurationComposerVariant, type IdentityPickerPlacement } from "./dropComposer.types";
export { DropMode } from "./dropComposer.types";
interface PrivilegedDropCreatorProps {
  readonly activeDrop: ActiveDropState | null;
  readonly onCancelReplyQuote: () => void;
  readonly onDropAddedToQueue: () => void;
  readonly onAllDropsAdded?: (() => void) | undefined;
  readonly onExitFixedDropMode?: (() => void) | undefined;
  readonly wave: ApiWave;
  readonly dropId: string | null;
  readonly fixedDropMode: DropMode;
  readonly curationComposerVariant?: CurationComposerVariant | undefined;
  readonly initialCurationUrl?: string | null | undefined;
  readonly onSubmitCurationUrl?: ((url: string) => void) | undefined;
  readonly canSubmitCurationUrl?: boolean | undefined;
  readonly curationUrlSubmitRestrictionMessage?: string | null | undefined;
  readonly externalAttachmentDrop?: {
    readonly token: number;
    readonly files: File[];
  } | null | undefined;
  readonly onExternalAttachmentDropConsumed?: (() => void) | undefined;
  readonly termsSignatureFlowEnabled?: boolean | undefined;
  readonly identityPickerPlacement?: IdentityPickerPlacement | undefined;
}
export default function PrivilegedDropCreator(t0) {
  const $ = _c(39);
  const {
    activeDrop,
    onCancelReplyQuote,
    wave,
    dropId,
    fixedDropMode,
    onAllDropsAdded,
    onExitFixedDropMode,
    onDropAddedToQueue,
    curationComposerVariant: t1,
    initialCurationUrl: t2,
    onSubmitCurationUrl,
    canSubmitCurationUrl,
    curationUrlSubmitRestrictionMessage,
    externalAttachmentDrop,
    onExternalAttachmentDropConsumed,
    termsSignatureFlowEnabled: t3,
    identityPickerPlacement: t4
  } = t0;
  const curationComposerVariant = t1 === undefined ? "default" : t1;
  const initialCurationUrl = t2 === undefined ? null : t2;
  const termsSignatureFlowEnabled = t3 === undefined ? true : t3;
  const identityPickerPlacement = t4 === undefined ? "modal" : t4;
  const {
    connectedProfile,
    activeProfileProxy
  } = useAuth();
  const t5 = !!connectedProfile?.handle;
  const t6 = !!activeProfileProxy;
  const t7 = !wave.chat.enabled;
  const t8 = wave.participation.period?.min ?? null;
  const t9 = wave.participation.period?.max ?? null;
  const t10 = wave.participation.no_of_applications_allowed_per_participant ?? null;
  let t11;
  if ($[0] !== t10 || $[1] !== t5 || $[2] !== t6 || $[3] !== t7 || $[4] !== t8 || $[5] !== t9 || $[6] !== wave.chat.authenticated_user_eligible || $[7] !== wave.metrics.your_participation_drops_count || $[8] !== wave.participation.authenticated_user_eligible) {
    t11 = {
      isLoggedIn: t5,
      isProxy: t6,
      canChat: wave.chat.authenticated_user_eligible,
      canDrop: wave.participation.authenticated_user_eligible,
      chatDisabled: t7,
      submissionStarts: t8,
      submissionEnds: t9,
      maxDropsCount: t10,
      identityDropsCount: wave.metrics.your_participation_drops_count
    };
    $[0] = t10;
    $[1] = t5;
    $[2] = t6;
    $[3] = t7;
    $[4] = t8;
    $[5] = t9;
    $[6] = wave.chat.authenticated_user_eligible;
    $[7] = wave.metrics.your_participation_drops_count;
    $[8] = wave.participation.authenticated_user_eligible;
    $[9] = t11;
  } else {
    t11 = $[9];
  }
  const {
    submissionRestriction,
    chatRestriction
  } = useDropPrivileges(t11);
  if (submissionRestriction !== null && chatRestriction !== null) {
    let t12;
    if ($[10] !== chatRestriction || $[11] !== submissionRestriction) {
      t12 = <DropPlaceholder type="both" chatRestriction={chatRestriction} submissionRestriction={submissionRestriction} />;
      $[10] = chatRestriction;
      $[11] = submissionRestriction;
      $[12] = t12;
    } else {
      t12 = $[12];
    }
    return t12;
  }
  if (fixedDropMode === DropMode.CHAT && chatRestriction !== null) {
    let t12;
    if ($[13] !== chatRestriction) {
      t12 = <DropPlaceholder type="chat" chatRestriction={chatRestriction} />;
      $[13] = chatRestriction;
      $[14] = t12;
    } else {
      t12 = $[14];
    }
    return t12;
  }
  if (fixedDropMode === DropMode.PARTICIPATION && submissionRestriction !== null) {
    let t12;
    if ($[15] !== submissionRestriction) {
      t12 = <DropPlaceholder type="submission" submissionRestriction={submissionRestriction} />;
      $[15] = submissionRestriction;
      $[16] = t12;
    } else {
      t12 = $[16];
    }
    return t12;
  }
  let t12;
  if ($[17] !== chatRestriction || $[18] !== submissionRestriction) {
    t12 = {
      submissionRestriction,
      chatRestriction
    };
    $[17] = chatRestriction;
    $[18] = submissionRestriction;
    $[19] = t12;
  } else {
    t12 = $[19];
  }
  let t13;
  if ($[20] !== activeDrop || $[21] !== canSubmitCurationUrl || $[22] !== curationComposerVariant || $[23] !== curationUrlSubmitRestrictionMessage || $[24] !== dropId || $[25] !== externalAttachmentDrop || $[26] !== fixedDropMode || $[27] !== identityPickerPlacement || $[28] !== initialCurationUrl || $[29] !== onAllDropsAdded || $[30] !== onCancelReplyQuote || $[31] !== onDropAddedToQueue || $[32] !== onExitFixedDropMode || $[33] !== onExternalAttachmentDropConsumed || $[34] !== onSubmitCurationUrl || $[35] !== t12 || $[36] !== termsSignatureFlowEnabled || $[37] !== wave) {
    t13 = <CreateDrop activeDrop={activeDrop} onCancelReplyQuote={onCancelReplyQuote} onAllDropsAdded={onAllDropsAdded} onExitFixedDropMode={onExitFixedDropMode} wave={wave} dropId={dropId} fixedDropMode={fixedDropMode} privileges={t12} onDropAddedToQueue={onDropAddedToQueue} curationComposerVariant={curationComposerVariant} initialCurationUrl={initialCurationUrl} onSubmitCurationUrl={onSubmitCurationUrl} canSubmitCurationUrl={canSubmitCurationUrl} curationUrlSubmitRestrictionMessage={curationUrlSubmitRestrictionMessage} externalAttachmentDrop={externalAttachmentDrop} onExternalAttachmentDropConsumed={onExternalAttachmentDropConsumed} termsSignatureFlowEnabled={termsSignatureFlowEnabled} identityPickerPlacement={identityPickerPlacement} />;
    $[20] = activeDrop;
    $[21] = canSubmitCurationUrl;
    $[22] = curationComposerVariant;
    $[23] = curationUrlSubmitRestrictionMessage;
    $[24] = dropId;
    $[25] = externalAttachmentDrop;
    $[26] = fixedDropMode;
    $[27] = identityPickerPlacement;
    $[28] = initialCurationUrl;
    $[29] = onAllDropsAdded;
    $[30] = onCancelReplyQuote;
    $[31] = onDropAddedToQueue;
    $[32] = onExitFixedDropMode;
    $[33] = onExternalAttachmentDropConsumed;
    $[34] = onSubmitCurationUrl;
    $[35] = t12;
    $[36] = termsSignatureFlowEnabled;
    $[37] = wave;
    $[38] = t13;
  } else {
    t13 = $[38];
  }
  return t13;
}